var rdot = /\.(\d*)$/;
var rleadzero = /^0+/;
function toIntStr(num) {
    var numStr = Number(num).toString();
    var exponent = 0;
    numStr = numStr
        .replace(rdot, function (str, p) {
        exponent = p.length;
        return p;
    })
        .replace(rleadzero, '');
    return {
        numStr: numStr,
        exponent: exponent,
    };
}
function toFloatStr(numString, exponent) {
    if (exponent) {
        var length = numString.length;
        if (exponent < length) {
            numString = numString.substr(0, length - exponent) + '.' + numString.substr(length - exponent);
        }
        else {
            numString = '0.' + Array(exponent - length + 1).join('0') + numString;
        }
    }
    return numString;
}
/**
 * 元转分
 * @param  {string|number} amount
 * @return {number}
 */
export var toFen = function (amount) {
    var result = toIntStr(amount);
    var fen = toFloatStr(result.numStr + '00', result.exponent);
    return Number(fen);
};
/**
 * 分转元
 * @param {*} amount
 */
export var toYuan = function (amount) {
    var result = toIntStr(amount);
    var yuan = toFloatStr(result.numStr, result.exponent + 2);
    return Number(yuan);
};
/**
 * 元转元K
 * @param {*} amount  1000  转为1K
 */
export var toKYuan = function (amount) {
    var result = toIntStr(amount);
    var num = toFloatStr(result.numStr, result.exponent + 3);
    return Number(num);
};
export var toFixed = function (num, fixed) {
    var re = new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?');
    return parseFloat(num.toString().match(re)[0]);
};
/*
 * 分转万元
 */
export var fenToWan = function (num, decimal) {
    if (decimal === void 0) { decimal = 2; }
    if (!num || num === 0) {
        num = 0;
    }
    else {
        num = num / 1000000;
    }
    if (decimal >= 0) {
        num = toFixed(num, decimal);
    }
    return num;
};
/**
 * 利率 或者 元转万元
 */
export var toRate = function (num, decimal) {
    if (decimal === void 0) { decimal = 2; }
    if (!num || num === 0) {
        num = 0;
    }
    else {
        num = num / 10000;
    }
    if (decimal >= 0) {
        num = toFixed(num, decimal);
    }
    return num;
};
/**
 * 数字转中文大写
 */
export var toUpperCaseNumber = function (n) {
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
        return;
    }
    var unit = '千百拾亿千百拾万千百拾元角分', str = '';
    n += '00';
    var p = n.indexOf('.');
    if (p >= 0) {
        n = n.substring(0, p) + n.substr(p + 1, 2);
    }
    unit = unit.substr(unit.length - n.length);
    for (var i = 0; i < n.length; i++) {
        str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
    }
    return str
        .replace(/零(千|百|拾|角)/g, '零')
        .replace(/(零)+/g, '零')
        .replace(/零(万|亿|元)/g, '$1')
        .replace(/(亿)万|壹(拾)/g, '$1$2')
        .replace(/^元零?|零分/g, '')
        .replace(/元$/g, '元整');
};
export var numberWithCommas = function (num) {
    // return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
